export default "__VITE_ASSET__CorJiPMP__"